export default "__VITE_ASSET__DV5GiBD4__"